import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { SessionStorage } from '../../../common/helpers/session-storage';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const enterTrainingMode = async (): Promise<void> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/training-mode/enter',
    method: 'GET',
    headers: {
      token: SessionStorage.sessionId(),
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };
  await emeraldRequest(emeraldRequestParams);
};

export const exitTrainingMode = async (prevSession): Promise<void> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/training-mode/exit',
    method: 'GET',
    headers: {
      token: prevSession ? SessionStorage.sessionId() : '',
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: !prevSession,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  await emeraldRequest(emeraldRequestParams);
};
